import { render, staticRenderFns } from "./ChartMoveSelector.vue?vue&type=template&id=3679de56&scoped=true&"
import script from "./ChartMoveSelector.vue?vue&type=script&lang=js&"
export * from "./ChartMoveSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChartMoveSelector.vue?vue&type=style&index=0&id=3679de56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679de56",
  null
  
)

export default component.exports